import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-onboarding-left-panel',
  templateUrl: './client-onboarding-left-panel.component.html',
  styleUrls: ['./client-onboarding-left-panel.component.scss'],
})
export class ClientOnboardingLeftPanelComponent implements OnInit, OnChanges {

  staffyLogo: string = 'assets/images/staffy-healthcare-logo-icon.png'; 
  @Input() expertise?: string = 'healthcare';
  constructor() { }

  ngOnInit() {
    this.updateLogo();
  }

  ngOnChanges() {
    this.updateLogo();
  }

  updateLogo() {
    if(!this.expertise || this.expertise?.toLowerCase() === 'healthcare') {
      this.staffyLogo = 'assets/images/staffy-healthcare-logo-icon.png'
    } else {
      this.staffyLogo = 'assets/images/staffy-hospitality-logo-icon.png'
    }
  }

}
